import { Fragment, memo } from 'react'
import { Trade } from '@pancakeswap/sdk'
import { Text, Flex, ChevronRightIcon } from '@pancakeswap/uikit'
import { unwrappedToken } from 'utils/wrappedCurrency'
import { useNetwork } from 'wagmi'
import { formatSymbol, getChainId } from 'config/constants/exchange'

export default memo(function SwapRoute({ trade }: { trade: Trade }) {
  const { chain } = useNetwork()
  const chainId = getChainId(chain);
  return (
    <Flex flexWrap="wrap" width="100%" justifyContent="flex-end" alignItems="center">
      {trade.route.path.map((token, i, path) => {
        const isLastItem: boolean = i === path.length - 1
        const currency = unwrappedToken(token)
        return (
          // eslint-disable-next-line react/no-array-index-key
          <Fragment key={i}>
            <Flex alignItems="end">
              <Text fontSize="12px" ml="0.125rem" mr="0.125rem">
                {formatSymbol(currency.symbol , chainId)}
              </Text>
            </Flex>
            {!isLastItem && <ChevronRightIcon width="12px" />}
          </Fragment>
        )
      })}
    </Flex>
  )
})
